import { mentorAndGrade } from '../../../../../img/images';
import { InstructionTickIcon } from '../../../../shared/icons/icons';
import { ILocalization } from '../../../../../localization/definitions/types';

interface Props {
    localization: ILocalization;
}

export const MentorAndGradeSlideImage = () => {
    return (
        <div className='carousel-img w-100 h-100'>
            <div className='project-handling-slide'>
                <img alt='' src={mentorAndGrade} />
            </div>
        </div>
    );
};

export const MentorAndGradeSlideImageSrc = mentorAndGrade;

export const MentorAndGradeSlideContent = ({ localization }: Props) => {
    const { mentorAndGradeSlide } =
        localization.localizationStrings.susy.thesisManagement.tutorial
            .supervisor.slides;

    return (
        <div className='tutorial-content-wrapper'>
            <h1>{mentorAndGradeSlide.mentorAndGrade}​​​</h1>
            <div className='instruction-row'>
                <div className='instruction-tick'>
                    <InstructionTickIcon />
                    <div />
                </div>
                <div className='instruction-content'>
                    {mentorAndGradeSlide.whenTheStudent}{' '}
                    <span className='badge thesisOverview-card-badge mb-0 thesisOverview-card-badge-accepted'>
                        {mentorAndGradeSlide.registered}
                    </span>{' '}
                    {mentorAndGradeSlide.hisOrHer}
                </div>
            </div>
            <div className='instruction-row'>
                <div className='instruction-tick'>
                    <InstructionTickIcon />
                    <div />
                </div>
                <div className='instruction-content'>
                    {mentorAndGradeSlide.onceTheFinal}{' '}
                    <span className='badge thesisOverview-card-badge mb-0 thesisOverview-card-badge-handedIn'>
                        {mentorAndGradeSlide.handedIn}
                    </span>
                    {', '}
                    {mentorAndGradeSlide.yourGradingPeriod}
                </div>
            </div>
        </div>
    );
};
